// extracted by mini-css-extract-plugin
export var component = "ContentNodeTeaser-module--component--HZA6p";
export var excerpt = "ContentNodeTeaser-module--excerpt--7EjtM";